// extracted by mini-css-extract-plugin
export default {"image":"P6-z","loaded":"Q6-z"};